
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides",
      function () {
        return require("private-next-pages/guides.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides"])
      });
    }
  